import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Submit_Btn.css'
import { faAngleRight, faArrowRight, faPlay } from '@fortawesome/free-solid-svg-icons'

const Submit_Btn = (props) => {
    return (
        <button className="Submit_Btn" onClick={props?.onClick} type='submit'>

            <p className='btn_text'>{props?.btn_name}</p>
{/* 
            <div className='icon_holder'>
                <FontAwesomeIcon icon={faArrowRight} className='icon' />
            </div> */}

        </button>
    )
}

export default Submit_Btn
